<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4 text--primary"
        ><p v-html="message"></p
      ></v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import messages from "@/common/data/messages.data";

export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {},
  }),
  methods: {
    open(condition, messageKey) {
      if (
        condition === null ||
        condition === undefined ||
        (condition && !!condition)
      ) {
        this.options = {
          confirmButtonLabel: this.$t("COMMON__ACTION__CONFIRM"),
          confirmButtonColor: "primary darken-1",
          color: "primary",
          width: 400,
          zIndex: 200,
        };

        let [resource, action] = messageKey.split(".");
        let config = messages.dialog[resource][action];
        this.dialog = true;
        this.title = this.$t(config.title);
        this.message = this.$t(config.message);
				setTimeout(() => {
					this.dialog = false;
				}, 2000);
      }
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>
